<template>
  <div class="enter_form">
    <el-row type="flex" :gutter="37" justify="space-between">
      <el-col>
        <div
          @click="form.shopType='offshop'"
          :class="{is_active:form.shopType=='offshop'}"
          class="shop_select"
        >
          <h3>线下店铺</h3>
          <div class="shop-line"></div>
          <p>
            我有线下实体店面
            希望能线下收款
          </p>
        </div>
      </el-col>
      <el-col>
        <div
          @click="form.shopType='onshop'"
          :class="{is_active:form.shopType=='onshop'}"
          class="shop_select"
        >
          <h3>线上店铺</h3>
          <div class="shop-line"></div>
          <p>我要网上卖商品做网店店主</p>
        </div>
      </el-col>
    </el-row>
    <el-row class="btn-submit">
      <el-button type="danger" @click="next" :disabled="!form.shopType">下一步，填写店铺信息</el-button>
    </el-row>
    <div v-if="form.shopType=='offshop'" class="confirm">
      确认有
      <span>线下实体店面</span>
      ，申请线下店铺
    </div>
    <div v-if="form.shopType=='onshop'" class="confirm">
      确认申请
      <span>线上店铺</span>
    </div>
  </div>
</template>
<script>
export default {
  model: {
    prop: "form"
  },
  props: {
    form: Object
  },
  methods: {
    next() {
      this.form.step = 2;
      this.$emit("update:form", this.form);
    }
  }
};
</script>
<style lang="less" scoped>
.enter_form {
  width: 417px;

  .el-row--flex {
    margin-bottom: 36px;

    .shop_select {
      width: 190px;
      border-radius: 4px;
      border: 1px solid #eeeeee;
      text-align: center;
      padding: 18px;
      h3 {
        font-size: 16px;
        margin-top: 30px;
        font-weight: 600;
        color: #555555;
      }
      .shop-line {
        width: 24px;
        height: 2px;
        background-color: #e60616;
        margin: 16px auto 10px auto;
      }
      p {
        font-size: 16px;
        color: #555555;
        padding: 8px 10px 10px 10px;
        line-height: 30px;
      }
    }
    .is_active {
      border: 1px solid #e60616;
      h3 {
        color: #e60616;
      }
      p {
        color: #e60616;
      }
    }
  }
  .btn-submit {
    .el-button--danger:not([disabled]) {
      background-color: #e60616;
    }
  }
  .confirm {
    text-align: center;
    padding-top: 20px;
    margin: 0 auto;
    font-size: 16px;
    color: #999999;

    span {
      color: #e60616;
    }
  }
}
</style>